import _sfc_main from "./PickerView.vue2.js";
/* empty css                */
import _export_sfc from "../../../_virtual/_plugin-vue_export-helper.js";
const PickerView = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-2358f95a"]]);
export {
  PickerView as default
};
//# sourceMappingURL=PickerView.vue.js.map
